import * as React from 'react'

export const StageQuestion = props => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12633)">
      <path
        d="M33.1674 8.66097C34.9165 7.63532 37.0835 7.63532 38.8326 8.66097L60.9454 21.6273C62.6597 22.6325 63.7128 24.4708 63.7128 26.458V52.542C63.7128 54.5292 62.6597 56.3675 60.9454 57.3727L38.8326 70.339C37.0835 71.3647 34.9165 71.3647 33.1674 70.339L11.0546 57.3727C9.34033 56.3675 8.28719 54.5292 8.28719 52.542V26.458C8.28719 24.4708 9.34033 22.6325 11.0546 21.6273L33.1674 8.66097Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.1902 15.6192C34.9278 14.6112 37.0722 14.6112 38.8099 15.6192L55.5006 25.3009C57.2277 26.3027 58.2908 28.1483 58.2908 30.1449V49.554C58.2908 51.5506 57.2277 53.3962 55.5006 54.398L38.8099 64.0798C37.0722 65.0877 34.9278 65.0877 33.1902 64.0798L16.4994 54.398C14.7723 53.3962 13.7093 51.5506 13.7093 49.554V30.1449C13.7093 28.1483 14.7723 26.3027 16.4994 25.3009L33.1902 15.6192Z"
        fill="#DB5A5F"
      />
      <path
        d="M51.8012 49.934L40.8696 57.9213L43.851 49.934H51.8012Z"
        fill="#CEC198"
      />
      <path
        d="M45.8385 25.9708C49.1317 25.9708 51.8014 28.6534 51.8014 31.962V49.9337L40.8698 57.922V57.921L51.8014 49.9337H26.9567C23.6637 49.9337 20.994 47.252 20.9938 43.9435V31.962C20.9938 28.6534 23.6636 25.9708 26.9567 25.9708H45.8385Z"
        fill="#FFFAC7"
      />
      <path
        d="M36.2983 43.9432C37.1215 43.9433 37.789 44.6138 37.789 45.4409C37.789 46.2679 37.1215 46.9384 36.2983 46.9386C35.4751 46.9386 34.8077 46.268 34.8077 45.4409C34.8077 44.6137 35.4751 43.9432 36.2983 43.9432Z"
        fill="#524F4D"
      />
      <path
        d="M36.7952 27.9677C40.0883 27.9679 42.758 30.7292 42.758 34.135C42.7579 36.7924 41.1322 39.0554 38.8537 39.922C38.1828 40.1771 37.6464 40.7712 37.6464 41.4919V41.6605C37.6464 42.3695 37.0748 42.9447 36.3692 42.9447C35.6635 42.9447 35.091 42.3695 35.091 41.6605V40.0244C35.091 38.9508 35.8012 37.9524 36.7952 37.6589C38.6768 37.6588 40.2025 36.0811 40.2026 34.135C40.2026 32.1888 38.6769 30.6113 36.7952 30.6111C35.3418 30.6111 34.1006 31.5519 33.611 32.8772C33.3655 33.5419 32.8153 34.135 32.1097 34.135C31.4043 34.1348 30.8187 33.554 30.9596 32.8596C31.5277 30.0657 33.9249 27.9677 36.7952 27.9677Z"
        fill="#524F4D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12633"
        x="-4"
        y="0"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12633"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12633"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
